import { useContext } from 'react';

import { HoneycombFormatterContext } from '../context/honeycomb-formatter.context.js';

export const useHoneycombFormatterConfig = () => {
  return useContext(HoneycombFormatterContext);
};
